import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiPut } from "@/apis/client";
import type { IApiResponse } from "@/apis/client";

export interface IUpdateGroupUsersRequest {
  user_ids: string[];
}

// API 함수
const updateGroupUsers = async (
  groupId: string,
  data: IUpdateGroupUsersRequest
): Promise<IApiResponse<any>> => {
  return apiPut(`/groups/${groupId}/users`, data);
};

// React Query mutation hook
export const useMutationUpdateGroupUsers = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      groupId,
      data,
    }: {
      groupId: string;
      data: IUpdateGroupUsersRequest;
    }) => updateGroupUsers(groupId, data),
    onSuccess: (_, { groupId }) => {
      // 관련된 쿼리들을 무효화하여 최신 데이터로 업데이트
      queryClient.invalidateQueries({ queryKey: ["group", groupId] });
      queryClient.invalidateQueries({ queryKey: ["groups"] });
    },
  });
};
